import { cn } from '@workspace/ui/lib/utils';

interface LoadingIconProps {
    size?: number;
    theme?: 'dark' | 'light';
    color?: string;
    className?: string;
}

export const LoadingIcon = ({ size = 24, theme, color, className }: LoadingIconProps) => {
    const scale = size / 48;
    const list = new Array(8).fill(0);
    return (
        <div className="relative" style={{ width: size, height: size }}>
            <div className="absolute origin-top-left" style={{ transform: `scale(${scale})` }}>
                <div className="relative w-12 h-12 inline-block origin-center" >
                    {list.map((_, index) =>{
                        let itemClassName = 'absolute w-full h-full origin-center flex justify-center animate-loading-icon';
                        const style: React.CSSProperties = {
                            rotate: `${index * 45}deg`,
                            animationDelay: `${index * 0.15}s`,
                        };
                        const innerStyle: React.CSSProperties = {};
                        if (color) {
                            innerStyle.backgroundColor = color;
                        } else if (theme) {
                            innerStyle.backgroundColor = theme === 'dark' ? '#000' : '#fff';
                        }
                        return (
                            <div className={itemClassName} key={index} style={style}>
                                <div className={cn('block w-1 h-3 rounded-full bg-foreground', className)} style={innerStyle} />
                            </div>
                        );
                    })}
                </div>
            </div>
        </div>
        
    )
}